import { render, staticRenderFns } from "./oil.vue?vue&type=template&id=e98be556&scoped=true"
import script from "./oil.vue?vue&type=script&lang=js"
export * from "./oil.vue?vue&type=script&lang=js"
import style0 from "./oil.vue?vue&type=style&index=0&id=e98be556&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98be556",
  null
  
)

export default component.exports